import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendEmailVerification, signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo, deleteUser, updateEmail } from 'firebase/auth';
import { cloudFunctionV2 } from '../api';
import mixpanel from 'mixpanel-browser';

export const createUser = (email, password) => {
	const auth = getAuth();
	return new Promise(resolve => {
		createUserWithEmailAndPassword(auth, email, password)
		.then((userCredential) => {
			const data = {
				user: userCredential.user,
				status: 200,
				message: "Success",
				errorCode: ""
			}
			resolve(data);
		})
		.catch((error) => {
			const data = {
				user: "",
				status: 400,
				message: error.message,
				errorCode: error.code
			}
			resolve(data);
		});
	})
}

export const getUser = (email, password) => {
	const auth = getAuth();
	return new Promise(resolve => {
		signInWithEmailAndPassword(auth, email, password)
		.then((userCredential) => {
			// Store auth method in localStorage - persists across sessions
			localStorage.setItem('lastAuthMethod', 'email');
			const data = {
				code : "",
				message: "",
				status: 200,
				userId: userCredential.user.uid,
				user: userCredential.user
			};
			resolve(data);
		})
		.catch((error) => {
			const data = {
				code : error.code,
				message: error.message,
				status: 400,
				userId: "",
				user: ""
			};
			resolve(data);
		});
	});
}

export const signInWithGoogle = async() => {
	const auth = getAuth();
	const provider = new GoogleAuthProvider();
	return new Promise(resolve => {
		signInWithPopup(auth, provider)
		.then((result) => {
			// Store auth method in localStorage - persists across sessions
			localStorage.setItem('lastAuthMethod', 'google');
			const user = result.user;
			// isNewUser lets SignUp branch new vs returning Google accounts
			// client-side (no server round-trip), so new users can navigate
			// optimistically while returning users keep the awaited routing.
			const additional = getAdditionalUserInfo(result);
			const data = {
				code : "",
				message: "",
				status: 200,
				userId: user.uid,
				isNewUser: additional?.isNewUser === true,
				user: user
			};
			resolve(data);
		}).catch((error) => {
			const data = {
				code : error.code,
				message: error.message,
				status: 400,
				userId: "",
				user: ""
			};
			resolve(data);
		});
	});
}

export const resetPassword = async(email, continueUrl) => {
	const url = process.env.REACT_APP_SEND_PASSWORD_RESET;
	return cloudFunctionV2(url, { email, continueUrl });
}

export const emailVerification = async() => {
	const auth = getAuth();

	return new Promise(resolve => {
		sendEmailVerification(auth.currentUser)
		.then(() => {
			resolve(true);
		})
		.catch((err) => {
			console.log("Email verification error = ", err);
			resolve(false);
		});
	});
}

export const updateUserEmail = async(email) => {
	const auth = getAuth();
	return new Promise(resolve => {
		updateEmail(auth.currentUser, email)
		.then(() => {
			const success = {
				status: 200
			}
			resolve(success);
		})
		.catch((error) => {
			const failure = {
				status: 400,
				error: error
			}
			resolve(failure);
		});
	});
};

export const logout = async() => {
	const auth = getAuth();
	try {
		await signOut(auth);
		mixpanel.reset();
		return { status: 200, message: "" };
	} catch(error) {
		return { status: 400, message: error };
	}
}

export const userDeletion = (user) => {
	return new Promise(resolve => {
		deleteUser(user).then(() => {
			const data = {
				status: 200
			};
			resolve(data);
		}).catch((error) => {
			const data = {
				status: 400,
				message: error
			};
			resolve(data);
		});
	});
}

export const checkOnAuthStateChanged = async() => {
	const auth = getAuth();
	// authStateReady() resolves once the initial auth state is settled — no subscription leak
	await auth.authStateReady();
	const user = auth.currentUser;
	if (user) {
		const providerData = user.providerData;
		let emailChangeable = true;
		for (let index = 0; index < providerData.length; index++) {
			const providerId = providerData[index].providerId;
			if (providerId !== "password") {
				emailChangeable = false;
			}
		}
		return {
			status: 200,
			userId: user.uid,
			email: user.email,
			emailVerified: user.emailVerified,
			emailChangeable: emailChangeable,
			user: user
		};
	}
	return {
		status: 400,
		userId: "",
		email: "",
		emailVerified: "",
		emailChangeable: false
	};
}

